<template>
    <a @click.prevent="flipImage('toggle')" href="#!" data-title="Flip">
        <i class="far fa-sync"></i>
    </a>
</template>

<script type="text/ecmascript-6">
    export default {
        methods:{
            flipImage(image_side){
                window.emitter.emit('flip-button-clicked', image_side);
            }
        }
    }
</script>
